import dalysWebsiteImage from '../assets/images/dalys-website.png';
import dossierWebsiteImage from '../assets/images/dossier-website.png';
import iotDashboardImage from '../assets/images/iot-dashboard.png';
import smallOfficeImage from '../assets/images/small-business-website.jpg';
import seoBasicsImage from '../assets/images/seo-basics.jpg';
import TechStackImage from '../assets/images/tech-stack.jpg';
import getTractionOnlineImage from '../assets/images/get-traction-online.jpg';
import whatIsATechStackImage from '../assets/images/what-is-a-tech-stack.png';


export const blogPosts = [
  {
    id: 1,
    slug: "dalys-case-study",
    title: "Dalys Case Study",
    excerpt: "An in-depth look at the web design, UX & UI for Dalys.",
    content: `
      <p>The Dalys project started with a clear goal: to create a clean, modern website that communicates professionalism while making complex services easy to understand.</p>
      <p>We began by organizing a UX workshop with the Dalys team to map out their user personas, customer journeys, and key value propositions. From there, we built wireframes that emphasized clarity, intuitive structure, and trust.</p>
      <p>Visually, we used a calm, confident color scheme with industrial tones and sleek typography. Interactive elements were designed to guide users through service overviews and encourage contact requests.</p>
      <p>On the technical side, the website was built using a headless CMS, providing flexibility for Dalys to update content without developer input. SEO best practices were implemented throughout the structure.</p>
      <p>Since launch, Dalys has seen a 38% increase in lead generation through the website, and the team reports that prospects better understand their offering before the first meeting — making sales conversations more efficient.</p>
    `,
    author: "Julius van Leeuwen",
    date: "2025-07-10",
    imageUrl: dalysWebsiteImage,
    type: "Case Study",
    category: "Web Design, UX & UI Design"
  },
  {
    id: 2,
    slug: "why-your-small-business-needs-a-great-website",
    title: "Why Your Small Business Needs a Great Website",
    excerpt: "Discover how a professional website can boost your credibility, attract new customers, and drive growth for your small business.",
    content: `
      <p>In 2025, having a strong online presence isn't optional — it's essential. Whether you're a local bakery, a consultancy, or a freelance photographer, your website is your digital storefront.</p>
      <p>First impressions matter. A well-designed site instantly boosts your credibility. Visitors are more likely to trust your business if your site looks modern, is easy to navigate, and communicates clearly.</p>
      <p>But it’s not just about looks. A good website works for you 24/7 — showcasing your services, collecting leads, or even enabling direct sales while you sleep.</p>
      <p>Search engines like Google favor fast, mobile-friendly, content-rich sites. That means with the right setup, you can attract organic traffic — people already searching for what you offer.</p>
      <p>Finally, your website gives you control. Social media platforms change their rules constantly. Your site is your own space, fully customizable to reflect your brand and goals.</p>
      <p>In short: a great website is one of the smartest investments a small business can make.</p>
    `,
    author: "Julius van Leeuwen",
    date: "2025-07-03",
    imageUrl: smallOfficeImage,
    type: "Article",
    category: "Business, Web Presence"
  },
  {
    id: 3,
    slug: "full-stack-iot-platform-case-study",
    title: "Full Stack IOT Platform Case Study",
    excerpt: "The development of a complex, full-stack IoT platform.",
    content: `
      <p>For a client working with industrial sensors, we developed a full-stack IoT platform that enables real-time monitoring and analysis of machine data across multiple facilities.</p>
      <p>The platform needed to be secure, scalable, and intuitive. We implemented a Ruby on Rails backend integrated with MQTT messaging and built the frontend using React for dynamic dashboards and live updates.</p>
      <p>Role-based access control, detailed logging, and automated alerts were key components. The design focused on making complex data readable at a glance — using color-coded metrics, sparklines, and interactive charts.</p>
      <p>The project involved working closely with hardware teams to ensure data consistency, building custom APIs, and deploying to a secure cloud environment with monitoring and autoscaling.</p>
      <p>The result is a powerful yet user-friendly tool that helps the client detect issues earlier, reduce downtime, and gain actionable insights from their sensor data — all from a single interface.</p>
    `,
    author: "Julius van Leeuwen",
    date: "2025-06-23",
    imageUrl: iotDashboardImage,
    type: "Case Study",
    category: "Web Design, Custom Platform"
  },
  {
    id: 4,
    slug: "dossier-am-case-study",
    title: "Dossier AM Case Study",
    excerpt: "How we built a platform with a blog for Dossier Arbeidsmigranten.",
    content: `
      <p>Dossier Arbeidsmigranten is a platform focused on improving the visibility and discussion around migrant workers in the Netherlands. The goal was to create an accessible, informative website that could grow with the initiative.</p>
      <p>We started with a design sprint to define the core needs: a news/blog system, rich editorial pages, and a strong identity that matches the topic's societal relevance.</p>
      <p>The blog structure was a key component. We developed a custom publishing system with flexible content blocks and category tagging to help editors share news, research, and interviews in an organized way.</p>
      <p>For design, we used a calm but serious color palette, bold headlines, and editorial-style layouts. Accessibility and mobile responsiveness were central to the UX design process.</p>
      <p>Post-launch, the Dossier AM team reported increased engagement from journalists, policymakers, and researchers. The blog is now a trusted source within the niche and supports the broader mission of transparency and awareness.</p>
    `,
    author: "Julius van Leeuwen",
    date: "2025-06-12",
    imageUrl: dossierWebsiteImage,
    type: "Case Study",
    category: "Web Design, Blog"
  },
  {
    id: 5,
    slug: "seo-basics-for-beginners",
    title: "SEO Basics for Beginners",
    excerpt: "A simple guide to Search Engine Optimization to help your website rank higher in search results and attract more organic traffic.",
    content: `
      <p>Search Engine Optimization (SEO) is the process of making your website more visible on search engines like Google. It might sound technical, but the basics are simple and powerful.</p>
      <p>The foundation starts with keywords — the terms people type into search engines. You’ll want to research which keywords relate to your product or service, then naturally include them in your headings, content, and meta descriptions.</p>
      <p>Next up: on-page SEO. This means optimizing things like title tags, image alt texts, and URL slugs. A fast-loading, mobile-friendly site structure is also essential for ranking well.</p>
      <p>Content matters too. Publishing valuable, consistent content helps Google understand your site and builds authority over time. Think blog articles, FAQs, and case studies.</p>
      <p>Finally, links — both internal (within your site) and external (from others to you) — boost trust in the eyes of search engines.</p>
      <p>By applying these SEO basics, you can gradually increase your site’s visibility, attract more visitors, and grow your business — without paying for ads.</p>
    `,
    author: "Julius van Leeuwen",
    date: "2024-05-27",
    imageUrl: seoBasicsImage,
    type: "Article",
    category: "SEO, Marketing"
  },
  {
    id: 6,
    slug: "choosing-the-right-tech-stack",
    title: "Choosing the Right Tech Stack for Your Project",
    excerpt: "An overview of popular technology stacks and how to decide which one is the best fit for your web application's needs.",
    content: `
      <p>The technology stack you choose will define how your application is built, how scalable it is, and how easy it is to maintain over time. Choosing wisely is key.</p>
      <p>Popular stacks include:</p>
      <ul>
        <li><strong>MERN:</strong> MongoDB, Express, React, Node.js — great for real-time apps and modern UIs</li>
        <li><strong>LAMP:</strong> Linux, Apache, MySQL, PHP — classic and widely supported</li>
        <li><strong>Ruby on Rails:</strong> A full-stack framework known for speed of development and clean conventions</li>
      </ul>
      <p>Factors to consider when choosing:</p>
      <ul>
        <li>Your team’s expertise</li>
        <li>The complexity and scale of your application</li>
        <li>Performance requirements</li>
        <li>Community support and documentation</li>
        <li>Time to market</li>
      </ul>
      <p>For startups, a stack like Rails or MERN often provides the flexibility and speed needed. For enterprise-grade solutions, stricter architecture choices might be needed.</p>
      <p>There’s no one-size-fits-all, but with clear goals and an understanding of trade-offs, you can select a stack that sets your project up for long-term success.</p>
    `,
    author: "Julius van Leeuwen",
    date: "2024-05-02",
    imageUrl: TechStackImage,
    type: "Article",
    category: "Technology, Development"
  },
  {
    id: 7,
    slug: "what-is-a-tech-stack",
    title: "What is a Tech Stack?",
    excerpt: "A beginner-friendly explanation of what a technology stack is and why it's a crucial decision for any digital project.",
    content: `
      <p>Ever wondered what a website or application is actually made of? The answer lies in its 'tech stack' — a combination of programming languages, frameworks, databases, and tools that developers use to build and run it.</p>
      <p>Think of it like building a house. You need different materials and tools for the foundation, the frame, the plumbing, and the interior design. In the digital world, it's no different.</p>
      <p>A typical tech stack includes:</p>
      <ul>
        <li><strong>The Frontend (Client-Side):</strong> This is everything the user sees and interacts with. It’s built with languages like HTML, CSS, and JavaScript, often using frameworks like React or Vue.js to make it dynamic and responsive.</li>
        <li><strong>The Backend (Server-Side):</strong> This is the engine of the application. It handles logic, user authentication, and data processing. Technologies like Node.js, Ruby on Rails, or Python with Django are common choices.</li>
        <li><strong>The Database:</strong> This is where all the application data is stored, from user profiles to product inventories. Examples include PostgreSQL, MySQL (relational), and MongoDB (non-relational).</li>
      </ul>
      <p>Choosing the right stack is one of the most critical decisions in a project. It impacts performance, scalability, development speed, and even the ability to hire developers with the right skills. It's about selecting the best tools for the job to create a robust, efficient, and future-proof application.</p>
    `,
    author: "Julius van Leeuwen",
    date: "2025-07-15",
    imageUrl: whatIsATechStackImage,
    type: "Article",
    category: "Technology, Development"
  },
  {
    id: 8,
    slug: "how-to-get-more-traction-online",
    title: "How to Get More Traction Online",
    excerpt: "Practical strategies for increasing your online visibility and attracting more visitors, from content marketing to social media engagement.",
    content: `
      <p>Building a great website is the first step, but getting people to visit it — gaining traction — is the next big challenge. Here are some effective strategies to increase your online visibility.</p>
      <p><strong>1. Content is King:</strong> Regularly publishing high-quality content that is valuable to your target audience is the cornerstone of modern marketing. This includes blog posts, case studies, guides, and videos. Great content establishes your authority and gives people a reason to visit and return to your site.</p>
      <p><strong>2. Master SEO Basics:</strong> Search Engine Optimization (SEO) helps you show up in Google results when people are searching for what you offer. Focus on relevant keywords, create good meta descriptions, ensure your site is fast and mobile-friendly, and build internal links.</p>
      <p><strong>3. Be Active on the Right Social Media:</strong> You don't need to be everywhere. Find out where your target audience spends their time — whether it's LinkedIn, Instagram, or a niche forum — and build a genuine presence there. Share your content, engage in conversations, and provide value.</p>
      <p><strong>4. Build an Email List:</strong> An email list is a direct line to your most engaged audience. Offer a valuable incentive (like a free guide or a discount) for people to sign up. Use it to share your best content and build a relationship with your subscribers.</p>
      <p>Consistency is the key. By combining these strategies and patiently executing them, you can build sustainable online traction that drives long-term growth.</p>
    `,
    author: "Julius van Leeuwen",
    date: "2025-07-20",
    imageUrl: getTractionOnlineImage,
    type: "Article",
    category: "Marketing, SEO, Business"
  }
]; 